"use client";

import React, { useState, useRef, useEffect } from "react";
import Map from "./Map";

/**
 * Lazy-loads the Map component only when it enters the viewport.
 * Defers loading the Google Maps API (~3 KiB) until the user scrolls to the map.
 */
export default function LazyMap({ apiKey }) {
  const [isInView, setIsInView] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
        }
      },
      { rootMargin: "100px", threshold: 0 }
    );

    observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={containerRef} className="map-container-wrapper">
      {isInView ? (
        <Map apiKey={apiKey} />
      ) : (
        <div
          className="map-container map-placeholder"
          aria-label="Map loading"
          role="img"
          style={{ minHeight: 402, background: "#e9ecf2" }}
        />
      )}
    </div>
  );
}
